import { authorizedApiClient } from "../config";
import {
  CreateView,
  CreateViewResponse,
  DeleteView,
  GetViewByID,
  GetViewByIdResponse,
  GetViews,
  PinnedView,
  PinnedViewResponse,
  UpdateView,
} from "./viewEndpoints.interface";

export const createView = async ({
  view_name,
  view_description,
  display_mode = "list",
  icon,
  icon_type,
  icon_key,
  icon_asset_id,
  is_public,
  filters,
  entity_relation,
  metrics_time_frame = "last_30_days",
  selected_columns,
  workspace_id,
  owner_id,
  sort_fields,
  metrics,
  is_precreated,
  page_limit = 10,
}: CreateView) => authorizedApiClient.post<CreateViewResponse>(`/${workspace_id}/views`, {
  view_name,
  view_description,
  display_mode,
  icon, // Legacy field, kept for backward compatibility
  icon_type,
  icon_key,
  icon_asset_id,
  is_public,
  filters,
  entity_relation,
  is_precreated,
  metrics_time_frame,
  selected_columns,
  sort_fields,
  metrics,
  page_limit,
  workspace_id,
  owner_id,
});

export const updateViewInApi = async ({
  view_name,
  view_description = null,
  display_mode,
  icon = null,
  icon_type = null,
  icon_key = null,
  icon_asset_id = null,
  workspace_id,
  is_public,
  filters = {},
  entity_relation,
  metrics_time_frame,
  selected_columns,
  sort_fields,
  metrics,
  page_limit = 1,
  id,
}: UpdateView) => {
  // If filters is empty or has empty properties, use an empty object
  // Otherwise, use the provided filters
  const validFilters = (!filters || (filters.query_type === null && filters.predicates === null)) 
    ? {} 
    : filters;
  
  return authorizedApiClient.put<UpdateView>(`/${workspace_id}/views/${id}`, {
    view_name,
    view_description,
    display_mode,
    icon, // Legacy field
    icon_type,
    icon_key,
    icon_asset_id,
    is_public,
    filters: validFilters,
    entity_relation,
    metrics_time_frame,
    selected_columns,
    sort_fields,
    metrics,
    page_limit,
    id,
  });
};

export const getViewById = (
  {
    workspace_identifier,
    view_id,
  }: GetViewByID,
) => authorizedApiClient.get<GetViewByIdResponse>(`/api/v1/${workspace_identifier}/views/${view_id}`);

export const getViews = async ({ workspace_identifier }: GetViews) => authorizedApiClient.get(`/${workspace_identifier}/views/all`);

export const deleteViewInApi = async ({
  workspace_id,
  id,
}: DeleteView) => authorizedApiClient.delete(`/${workspace_id}/views/${id}`);

export const pinView = async (
  workspaceId: string,
  pinnedView: PinnedView,
) => authorizedApiClient.post<PinnedViewResponse>(
  `/api/v1/${workspaceId}/pinned_views`,
  pinnedView,
);

export const removePinnedView = (
  workspaceId: string,
  viewId: string,
) => authorizedApiClient.delete<PinnedViewResponse>(`/api/v1/${workspaceId}/pinned_views/${viewId}`);
